import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'

// Initialize Sentry for error monitoring
if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring
    // Session Replay
    replaysSessionSampleRate: 0.01, // Capture 1% of sessions for replay
    replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors
    // Release tracking
    release: import.meta.env.VITE_APP_VERSION || '1.0.0',
    beforeSend(event) {
      // Filter out development errors and sensitive data
      if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
        return null;
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(<App />);
